// src/types/audience/index.ts
var SubAudienceType = /* @__PURE__ */ ((SubAudienceType2) => {
  SubAudienceType2["client"] = "client";
  SubAudienceType2["nonClient"] = "nonClient";
  return SubAudienceType2;
})(SubAudienceType || {});

// src/types/campaigns/index.ts
var OrderPurchaseType = /* @__PURE__ */ ((OrderPurchaseType2) => {
  OrderPurchaseType2["STORE"] = "STORE";
  OrderPurchaseType2["ONLINE"] = "ONLINE";
  return OrderPurchaseType2;
})(OrderPurchaseType || {});
var QualifyingOrderPurchaseType = /* @__PURE__ */ ((QualifyingOrderPurchaseType2) => {
  QualifyingOrderPurchaseType2["InStoreAndOnline"] = "*";
  QualifyingOrderPurchaseType2["OnlineOnly"] = "ONLINE";
  QualifyingOrderPurchaseType2["InStoreOnly"] = "STORE";
  return QualifyingOrderPurchaseType2;
})(QualifyingOrderPurchaseType || {});
var CampaignTargetingType = /* @__PURE__ */ ((CampaignTargetingType2) => {
  CampaignTargetingType2["general"] = "general";
  CampaignTargetingType2["brandBuyers"] = "brandBuyers";
  CampaignTargetingType2["custom"] = "custom";
  CampaignTargetingType2["audience"] = "audience";
  return CampaignTargetingType2;
})(CampaignTargetingType || {});

// src/types/campaigns/originAppType.ts
var OriginAppType = /* @__PURE__ */ ((OriginAppType2) => {
  OriginAppType2["brandclub"] = "brandclub";
  OriginAppType2["clientApp"] = "clientApp";
  OriginAppType2["brandclubNetwork"] = "brandclubNetwork";
  return OriginAppType2;
})(OriginAppType || {});

// src/types/campaigns/campaignStatus.ts
var CampaignStatus = /* @__PURE__ */ ((CampaignStatus2) => {
  CampaignStatus2["pending"] = "pending";
  CampaignStatus2["live"] = "live";
  CampaignStatus2["paused"] = "paused";
  CampaignStatus2["ended"] = "ended";
  CampaignStatus2["outOfBudget"] = "outOfBudget";
  CampaignStatus2["archived"] = "archived";
  return CampaignStatus2;
})(CampaignStatus || {});

// src/types/campaigns/campaignFundSource.ts
var CampaignFundSource = /* @__PURE__ */ ((CampaignFundSource2) => {
  CampaignFundSource2["companyDivisionBudget"] = "companyDivisionBudget";
  CampaignFundSource2["brandBudget"] = "brandBudget";
  return CampaignFundSource2;
})(CampaignFundSource || {});

// src/types/campaigns/campaignType.ts
var CampaignType = /* @__PURE__ */ ((CampaignType2) => {
  CampaignType2["reviewRewardCampaign"] = "reviewRewardCampaign";
  CampaignType2["limitedTimePurchaseRewardCampaign"] = "limitedTimePurchaseRewardCampaign";
  CampaignType2["purchaseRewardCampaign"] = "purchaseRewardCampaign";
  CampaignType2["contentRewardCampaign"] = "contentRewardCampaign";
  CampaignType2["referralRewardCampaign"] = "referralRewardCampaign";
  CampaignType2["promoteBrandClubRewardCampaign"] = "promoteBrandClubRewardCampaign";
  CampaignType2["affiliateLinkCampaign"] = "affiliateLinkCampaign";
  CampaignType2["socialRewardCampaign"] = "socialRewardCampaign";
  CampaignType2["surveyRewardCampaign"] = "surveyRewardCampaign";
  CampaignType2["retailerConnectRewardCampaign"] = "retailerConnectRewardCampaign";
  CampaignType2["pageScanRewardCampaign"] = "pageScanRewardCampaign";
  CampaignType2["syncRewardCampaign"] = "syncRewardCampaign";
  CampaignType2["subscribeAndSaveRewardCampaign"] = "subscribeAndSaveRewardCampaign";
  CampaignType2["couponRewardCampaign"] = "couponRewardCampaign";
  CampaignType2["messagingCampaign"] = "messagingCampaign";
  CampaignType2["orderReceiptMessagingCampaign"] = "orderReceiptMessagingCampaign";
  CampaignType2["postPurchaseConnectMessagingCampaign"] = "postPurchaseConnectMessagingCampaign";
  CampaignType2["reviewRequestMessagingCampaign"] = "reviewRequestMessagingCampaign";
  CampaignType2["membershipRewardReceiptMessagingCampaign"] = "membershipRewardReceiptMessagingCampaign";
  CampaignType2["surveyRewardReceiptMessagingCampaign"] = "surveyRewardReceiptMessagingCampaign";
  CampaignType2["affiliateRewardReceiptMessagingCampaign"] = "affiliateRewardReceiptMessagingCampaign";
  CampaignType2["contentRewardReceiptMessagingCampaign"] = "contentRewardReceiptMessagingCampaign";
  CampaignType2["reviewRewardReceiptMessagingCampaign"] = "reviewRewardReceiptMessagingCampaign";
  CampaignType2["expiringRewardReminderMessagingCampaign"] = "expiringRewardReminderMessagingCampaign";
  CampaignType2["reorderRequestMessagingCampaign"] = "reorderRequestMessagingCampaign";
  CampaignType2["productRecommendationsMessagingCampaign"] = "productRecommendationsMessagingCampaign";
  CampaignType2["rewardRecommendationsMessagingCampaign"] = "rewardRecommendationsMessagingCampaign";
  return CampaignType2;
})(CampaignType || {});
var MessagingCampaignType = /* @__PURE__ */ ((MessagingCampaignType2) => {
  MessagingCampaignType2["messagingCampaign"] = "messagingCampaign";
  MessagingCampaignType2["orderReceiptMessagingCampaign"] = "orderReceiptMessagingCampaign";
  MessagingCampaignType2["postPurchaseConnectMessagingCampaign"] = "postPurchaseConnectMessagingCampaign";
  MessagingCampaignType2["reviewRequestMessagingCampaign"] = "reviewRequestMessagingCampaign";
  MessagingCampaignType2["membershipRewardReceiptMessagingCampaign"] = "membershipRewardReceiptMessagingCampaign";
  MessagingCampaignType2["surveyRewardReceiptMessagingCampaign"] = "surveyRewardReceiptMessagingCampaign";
  MessagingCampaignType2["affiliateRewardReceiptMessagingCampaign"] = "affiliateRewardReceiptMessagingCampaign";
  MessagingCampaignType2["contentRewardReceiptMessagingCampaign"] = "contentRewardReceiptMessagingCampaign";
  MessagingCampaignType2["reviewRewardReceiptMessagingCampaign"] = "reviewRewardReceiptMessagingCampaign";
  MessagingCampaignType2["expiringRewardReminderMessagingCampaign"] = "expiringRewardReminderMessagingCampaign";
  MessagingCampaignType2["reorderRequestMessagingCampaign"] = "reorderRequestMessagingCampaign";
  MessagingCampaignType2["productRecommendationsMessagingCampaign"] = "productRecommendationsMessagingCampaign";
  MessagingCampaignType2["rewardRecommendationsMessagingCampaign"] = "rewardRecommendationsMessagingCampaign";
  return MessagingCampaignType2;
})(MessagingCampaignType || {});
var getCampaignTypeDisplayName = (campaignType) => {
  switch (campaignType) {
    case "purchaseRewardCampaign" /* purchaseRewardCampaign */:
      return "Purchase Reward Campaign";
    case "limitedTimePurchaseRewardCampaign" /* limitedTimePurchaseRewardCampaign */:
      return "Daily Deal Reward Campaign";
    case "reviewRewardCampaign" /* reviewRewardCampaign */:
      return "Rating Campaign";
    case "referralRewardCampaign" /* referralRewardCampaign */:
      return "Referral Reward Campaign";
    case "promoteBrandClubRewardCampaign" /* promoteBrandClubRewardCampaign */:
      return "Membership Reward Campaign";
    case "surveyRewardCampaign" /* surveyRewardCampaign */:
      return "Survey Reward Campaign";
    case "contentRewardCampaign" /* contentRewardCampaign */:
      return "Content Reward Campaign";
    case "retailerConnectRewardCampaign" /* retailerConnectRewardCampaign */:
      return "Connect Reward Campaign";
    case "affiliateLinkCampaign" /* affiliateLinkCampaign */:
      return "Affiliate Reward Campaign";
    case "syncRewardCampaign" /* syncRewardCampaign */:
      return "Sync Reward Campaign";
    case "subscribeAndSaveRewardCampaign" /* subscribeAndSaveRewardCampaign */:
      return "Subscribe & Save Reward Campaign";
    case "couponRewardCampaign" /* couponRewardCampaign */:
      return "Coupon Reward Campaign";
  }
  return campaignType;
};

// src/types/campaigns/messagingCampaigns.ts
var MessagingCampaignTriggerMechanism = /* @__PURE__ */ ((MessagingCampaignTriggerMechanism2) => {
  MessagingCampaignTriggerMechanism2["scheduled"] = "scheduled";
  MessagingCampaignTriggerMechanism2["event"] = "event";
  return MessagingCampaignTriggerMechanism2;
})(MessagingCampaignTriggerMechanism || {});
var MessagingCampaignActivationType = /* @__PURE__ */ ((MessagingCampaignActivationType2) => {
  MessagingCampaignActivationType2["triggerBasedActivation"] = "triggerBasedActivation";
  MessagingCampaignActivationType2["customDateActivation"] = "customDateActivation";
  return MessagingCampaignActivationType2;
})(MessagingCampaignActivationType || {});
var CustomerBrandCommunicationType = /* @__PURE__ */ ((CustomerBrandCommunicationType2) => {
  CustomerBrandCommunicationType2["orderReceiptMessage"] = "orderReceiptMessage";
  CustomerBrandCommunicationType2["postPurchaseConnectMessage"] = "postPurchaseConnectMessage";
  CustomerBrandCommunicationType2["reviewRequestMessage"] = "reviewRequestMessage";
  CustomerBrandCommunicationType2["reorderRequestMessage"] = "reorderRequestMessage";
  CustomerBrandCommunicationType2["rewardRecommendationsMessage"] = "rewardRecommendationsMessage";
  CustomerBrandCommunicationType2["productRecommendationsMessage"] = "productRecommendationsMessage";
  return CustomerBrandCommunicationType2;
})(CustomerBrandCommunicationType || {});

// src/types/orders/index.ts
var OrderSource = /* @__PURE__ */ ((OrderSource2) => {
  OrderSource2["checkout"] = "checkout";
  OrderSource2["sync"] = "sync";
  OrderSource2["external"] = "external";
  return OrderSource2;
})(OrderSource || {});
var OrderEligibility = /* @__PURE__ */ ((OrderEligibility2) => {
  OrderEligibility2["eligible"] = "eligible";
  OrderEligibility2["notEligible"] = "notEligible";
  return OrderEligibility2;
})(OrderEligibility || {});

// src/types/rewards/index.ts
var RewardStatus = /* @__PURE__ */ ((RewardStatus2) => {
  RewardStatus2["locked"] = "locked";
  RewardStatus2["unlocked"] = "unlocked";
  RewardStatus2["pending"] = "pending";
  RewardStatus2["expired"] = "expired";
  RewardStatus2["deleted"] = "deleted";
  RewardStatus2["redacted"] = "redacted";
  return RewardStatus2;
})(RewardStatus || {});
var PaymentStatus = /* @__PURE__ */ ((PaymentStatus2) => {
  PaymentStatus2["eligible"] = "eligible";
  PaymentStatus2["notEligible"] = "notEligible";
  PaymentStatus2["pendingCashOut"] = "pendingCashOut";
  PaymentStatus2["cashOutSuccess"] = "cashOutSuccess";
  PaymentStatus2["cashOutFailed"] = "cashOutFailed";
  return PaymentStatus2;
})(PaymentStatus || {});
var RewardProcessingStatus = /* @__PURE__ */ ((RewardProcessingStatus2) => {
  RewardProcessingStatus2["queued"] = "queued";
  RewardProcessingStatus2["done"] = "done";
  RewardProcessingStatus2["error"] = "error";
  RewardProcessingStatus2["skipped"] = "skipped";
  return RewardProcessingStatus2;
})(RewardProcessingStatus || {});
var RewardUnlockStrategy = /* @__PURE__ */ ((RewardUnlockStrategy2) => {
  RewardUnlockStrategy2["Instant"] = "instant";
  RewardUnlockStrategy2["BrandedPurchase"] = "brandedPurchase";
  return RewardUnlockStrategy2;
})(RewardUnlockStrategy || {});
var RewardAppTargetingPlatformsType = /* @__PURE__ */ ((RewardAppTargetingPlatformsType2) => {
  RewardAppTargetingPlatformsType2["All"] = "all";
  RewardAppTargetingPlatformsType2["BrandclubWebAndMobile"] = "brandclubWebAndMobile";
  RewardAppTargetingPlatformsType2["ClientWebAndMobile"] = "clientWebAndMobile";
  RewardAppTargetingPlatformsType2["ClientWeb"] = "clientWeb";
  RewardAppTargetingPlatformsType2["ClientMobile"] = "clientMobile";
  return RewardAppTargetingPlatformsType2;
})(RewardAppTargetingPlatformsType || {});

// src/types/rewards/rewardType.ts
var RewardType = /* @__PURE__ */ ((RewardType2) => {
  RewardType2["customerReferralReward"] = "customerReferralReward";
  RewardType2["retailerConnectReward"] = "retailerConnectReward";
  RewardType2["promoteBrandClubCashBackReward"] = "promoteBrandClubCashBackReward";
  RewardType2["purchaseCashBackReward"] = "purchaseCashBackReward";
  RewardType2["limitedTimePurchaseCashBackReward"] = "limitedTimePurchaseCashBackReward";
  RewardType2["productReviewCashBackReward"] = "productReviewCashBackReward";
  RewardType2["affiliateLinkCashBackReward"] = "affiliateLinkCashBackReward";
  RewardType2["socialReward"] = "socialReward";
  RewardType2["surveyReward"] = "surveyReward";
  RewardType2["contentReward"] = "contentReward";
  RewardType2["pageScanReward"] = "pageScanReward";
  RewardType2["syncReward"] = "syncReward";
  RewardType2["subscribeAndSaveReward"] = "subscribeAndSaveReward";
  RewardType2["couponReward"] = "couponReward";
  RewardType2["cashOutFeeReward"] = "cashOutFeeReward";
  return RewardType2;
})(RewardType || {});
var rewardDisplayNames = {
  ["customerReferralReward" /* customerReferralReward */]: "App Referral Reward",
  ["retailerConnectReward" /* retailerConnectReward */]: "Connect Reward",
  ["promoteBrandClubCashBackReward" /* promoteBrandClubCashBackReward */]: "Membership Reward",
  ["purchaseCashBackReward" /* purchaseCashBackReward */]: "Purchase Reward",
  ["limitedTimePurchaseCashBackReward" /* limitedTimePurchaseCashBackReward */]: "Daily Deal Reward",
  ["productReviewCashBackReward" /* productReviewCashBackReward */]: "Review Reward",
  ["affiliateLinkCashBackReward" /* affiliateLinkCashBackReward */]: "Affiliate Reward",
  ["surveyReward" /* surveyReward */]: "Survey Reward",
  ["contentReward" /* contentReward */]: "Content Reward",
  ["syncReward" /* syncReward */]: "Sync Reward",
  ["subscribeAndSaveReward" /* subscribeAndSaveReward */]: "Subscribe & Save Reward",
  ["couponReward" /* couponReward */]: "Coupon Reward",
  ["socialReward" /* socialReward */]: "",
  ["pageScanReward" /* pageScanReward */]: "",
  ["cashOutFeeReward" /* cashOutFeeReward */]: "Cash Out Fee"
};
var rewardShortDisplayNames = {
  ["customerReferralReward" /* customerReferralReward */]: "Referral",
  ["retailerConnectReward" /* retailerConnectReward */]: "Connect",
  ["promoteBrandClubCashBackReward" /* promoteBrandClubCashBackReward */]: "Membership",
  ["purchaseCashBackReward" /* purchaseCashBackReward */]: "Purchase",
  ["limitedTimePurchaseCashBackReward" /* limitedTimePurchaseCashBackReward */]: "Daily Deal",
  ["productReviewCashBackReward" /* productReviewCashBackReward */]: "Review",
  ["affiliateLinkCashBackReward" /* affiliateLinkCashBackReward */]: "Affiliate",
  ["surveyReward" /* surveyReward */]: "Survey",
  ["contentReward" /* contentReward */]: "Content",
  ["syncReward" /* syncReward */]: "Sync",
  ["subscribeAndSaveReward" /* subscribeAndSaveReward */]: "Subscribe & Save",
  ["couponReward" /* couponReward */]: "Coupon",
  ["socialReward" /* socialReward */]: "",
  ["pageScanReward" /* pageScanReward */]: "",
  ["cashOutFeeReward" /* cashOutFeeReward */]: "Cash Out Fee"
};

// src/types/user/index.ts
var UserStatus = /* @__PURE__ */ ((UserStatus2) => {
  UserStatus2["pending"] = "pending";
  UserStatus2["enabled"] = "enabled";
  UserStatus2["disabled"] = "disabled";
  UserStatus2["waitlist"] = "waitlist";
  UserStatus2["deleted"] = "deleted";
  return UserStatus2;
})(UserStatus || {});

// src/types/company/contractType.ts
var ContractType = /* @__PURE__ */ ((ContractType2) => {
  ContractType2["paid"] = "paid";
  ContractType2["trial"] = "trial";
  return ContractType2;
})(ContractType || {});

// src/types/extension/index.ts
var APP_ACTIONS = /* @__PURE__ */ ((APP_ACTIONS2) => {
  APP_ACTIONS2["APP_INIT"] = "app/init";
  APP_ACTIONS2["APP_INIT_AUTH"] = "app/init/auth";
  APP_ACTIONS2["APP_LOGIN"] = "app/login";
  APP_ACTIONS2["APP_LOGOUT"] = "app/logout";
  APP_ACTIONS2["APP_SAVE_STATE"] = "app/saveState";
  APP_ACTIONS2["APP_GET_PROFILE"] = "app/getProfile";
  APP_ACTIONS2["APP_GET_REWARDS"] = "app/getRewards";
  APP_ACTIONS2["APP_SUBMIT_PURCHASES"] = "app/submitPurchaseHistory";
  APP_ACTIONS2["APP_SCAN_PURCHASES_START"] = "app/scanPurchases/start";
  APP_ACTIONS2["APP_SCAN_PURCHASES_STOP"] = "app/scanPurchases/stop";
  APP_ACTIONS2["APP_TABS_ACTIVE"] = "app/tabs/active";
  APP_ACTIONS2["APP_REFRESH_SESSION"] = "app/refreshSession";
  return APP_ACTIONS2;
})(APP_ACTIONS || {});
var SessionState = /* @__PURE__ */ ((SessionState2) => {
  SessionState2["NONE"] = "NONE";
  SessionState2["STARTED"] = "STARTED";
  SessionState2["STOPPED"] = "STOPPED";
  SessionState2["ENDED"] = "ENDED";
  SessionState2["SUBMITTED"] = "SUBMITTED";
  SessionState2["ERROR"] = "ERROR";
  return SessionState2;
})(SessionState || {});
var AuthStateEnum = /* @__PURE__ */ ((AuthStateEnum2) => {
  AuthStateEnum2["NONE"] = "NONE";
  AuthStateEnum2["LOGGED_IN"] = "LOGGED_IN";
  AuthStateEnum2["LOGGED_OUT"] = "LOGGED_OUT";
  AuthStateEnum2["LOGIN_EXPIRED"] = "LOGIN_EXPIRED";
  AuthStateEnum2["SERVER_ERROR"] = "SERVER_ERROR";
  return AuthStateEnum2;
})(AuthStateEnum || {});

// src/types/retailers/index.ts
var DEFAULT_DELIVERY_FEE_THRESHOLD = 10;
var RetailerReviewConfigStatus = /* @__PURE__ */ ((RetailerReviewConfigStatus2) => {
  RetailerReviewConfigStatus2["Enabled"] = "enabled";
  RetailerReviewConfigStatus2["Disabled"] = "disabled";
  return RetailerReviewConfigStatus2;
})(RetailerReviewConfigStatus || {});
var EligibilityStatus = /* @__PURE__ */ ((EligibilityStatus2) => {
  EligibilityStatus2["ENABLED"] = "enabled";
  EligibilityStatus2["DISABLED"] = "disabled";
  return EligibilityStatus2;
})(EligibilityStatus || {});

// src/types/notifications/index.ts
var NotificationStatus = /* @__PURE__ */ ((NotificationStatus2) => {
  NotificationStatus2["pending"] = "pending";
  NotificationStatus2["skipped"] = "skipped";
  NotificationStatus2["sent"] = "sent";
  NotificationStatus2["read"] = "read";
  NotificationStatus2["error"] = "error";
  NotificationStatus2["deleted"] = "deleted";
  return NotificationStatus2;
})(NotificationStatus || {});
var MessageChannelType = /* @__PURE__ */ ((MessageChannelType2) => {
  MessageChannelType2["push"] = "push";
  MessageChannelType2["email"] = "email";
  MessageChannelType2["text"] = "text";
  return MessageChannelType2;
})(MessageChannelType || {});
var NotificationTypeCategory = /* @__PURE__ */ ((NotificationTypeCategory2) => {
  NotificationTypeCategory2["messagingCampaign"] = "messagingCampaign";
  NotificationTypeCategory2["rewardsEarned"] = "rewardsEarned";
  NotificationTypeCategory2["payouts"] = "payouts";
  NotificationTypeCategory2["rewardsSummary"] = "rewardsSummary";
  NotificationTypeCategory2["customPush"] = "customPush";
  NotificationTypeCategory2["customText"] = "customText";
  NotificationTypeCategory2["accountEngagement"] = "accountEngagement";
  NotificationTypeCategory2["rewardTypeReminder"] = "rewardTypeReminder";
  return NotificationTypeCategory2;
})(NotificationTypeCategory || {});

// src/types/notifications/notificationType.ts
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["chewyLaunch"] = "chewyLaunch";
  NotificationType2["socialMedia"] = "socialMedia";
  NotificationType2["promoteProducts"] = "promoteProducts";
  NotificationType2["takeSurveys"] = "takeSurveys";
  NotificationType2["joinClubs"] = "joinClubs";
  NotificationType2["connectAccounts"] = "connectAccounts";
  NotificationType2["inviteAFriend"] = "inviteAFriend";
  NotificationType2["earnMoreRewards"] = "earnMoreRewards";
  NotificationType2["syncRewardsEarned"] = "syncRewardsEarned";
  NotificationType2["joinPromotedClubRewardsEarned"] = "joinPromotedClubRewardsEarned";
  NotificationType2["orderConfirmationRewardsEarned"] = "orderConfirmationRewardsEarned";
  NotificationType2["connectNewAccounts"] = "connectNewAccounts";
  NotificationType2["syncPurchases"] = "syncPurchases";
  NotificationType2["cashOutRewards"] = "cashOutRewards";
  NotificationType2["bestRewardsGeneric"] = "bestRewardsGeneric";
  NotificationType2["bestRewardsPersonalized"] = "bestRewardsPersonalized";
  NotificationType2["instantRewardsBlackFriday"] = "instantRewardsBlackFriday";
  NotificationType2["payoutConfirmed"] = "payoutConfirmed";
  NotificationType2["rewardsEarnedSummary"] = "rewardsEarnedSummary";
  NotificationType2["inviteAFriendRewardsEarned"] = "inviteAFriendRewardsEarned";
  NotificationType2["promoteProductsRewardsEarned"] = "promoteProductsRewardsEarned";
  NotificationType2["serverSideSyncComplete"] = "serverSideSyncComplete";
  NotificationType2["serverSideSyncFailed"] = "serverSideSyncFailed";
  NotificationType2["serverSideSyncStart"] = "serverSideSyncStart";
  NotificationType2["orderReceiptMessage"] = "orderReceiptMessage";
  NotificationType2["postPurchaseConnectMessage"] = "postPurchaseConnectMessage";
  NotificationType2["reviewRequestMessage"] = "reviewRequestMessage";
  NotificationType2["membershipRewardReceiptMessage"] = "membershipRewardReceiptMessage";
  NotificationType2["surveyRewardReceiptMessage"] = "surveyRewardReceiptMessage";
  NotificationType2["affiliateRewardReceiptMessage"] = "affiliateRewardReceiptMessage";
  NotificationType2["contentRewardReceiptMessage"] = "contentRewardReceiptMessage";
  NotificationType2["expiringRewardReminderMessage"] = "expiringRewardReminderMessage";
  NotificationType2["reviewReceiptMessage"] = "reviewReceiptMessage";
  NotificationType2["reorderRequestMessage"] = "reorderRequestMessage";
  NotificationType2["productRecommendationsMessage"] = "productRecommendationsMessage";
  NotificationType2["rewardRecommendationsMessage"] = "rewardRecommendationsMessage";
  NotificationType2["customPush"] = "customPush";
  return NotificationType2;
})(NotificationType || {});
var inboxNotificationTypes = [
  "orderReceiptMessage" /* orderReceiptMessage */,
  "postPurchaseConnectMessage" /* postPurchaseConnectMessage */,
  "reviewRequestMessage" /* reviewRequestMessage */,
  "membershipRewardReceiptMessage" /* membershipRewardReceiptMessage */,
  "surveyRewardReceiptMessage" /* surveyRewardReceiptMessage */,
  "affiliateRewardReceiptMessage" /* affiliateRewardReceiptMessage */,
  "contentRewardReceiptMessage" /* contentRewardReceiptMessage */,
  // NotificationType.expiringRewardReminderMessage,
  "reviewReceiptMessage" /* reviewReceiptMessage */,
  "reorderRequestMessage" /* reorderRequestMessage */,
  "productRecommendationsMessage" /* productRecommendationsMessage */,
  "rewardRecommendationsMessage" /* rewardRecommendationsMessage */
];

// src/types/notifications/notificationsConstants.ts
var NotificationsConstants = class {
};
NotificationsConstants.ALL_SENT_STATUSES = [
  "sent" /* sent */,
  "read" /* read */,
  "deleted" /* deleted */
];
NotificationsConstants.ALL_READ_STATUSES = ["read" /* read */, "deleted" /* deleted */];

// src/types/cms/page.ts
var BrandclubPageType = /* @__PURE__ */ ((BrandclubPageType2) => {
  BrandclubPageType2["Home"] = "Home";
  BrandclubPageType2["Category"] = "Category";
  BrandclubPageType2["CustomCategoryGroup"] = "CustomCategoryGroup";
  BrandclubPageType2["Subcategory"] = "Subcategory";
  BrandclubPageType2["Explore"] = "Explore";
  BrandclubPageType2["Collection"] = "Collection";
  BrandclubPageType2["Editorial"] = "Editorial";
  BrandclubPageType2["Product"] = "Product";
  BrandclubPageType2["Search"] = "Search";
  return BrandclubPageType2;
})(BrandclubPageType || {});
var PageStatus = /* @__PURE__ */ ((PageStatus2) => {
  PageStatus2["Visible"] = "VISIBLE";
  PageStatus2["NotVisible"] = "NOT_VISIBLE";
  return PageStatus2;
})(PageStatus || {});

// src/types/cms/widget.ts
var WidgetId = /* @__PURE__ */ ((WidgetId2) => {
  WidgetId2["BrandclubNavigation"] = "Brandclub_Navigation";
  WidgetId2["BrandHeader"] = "Brand_Header";
  WidgetId2["BrandHeaderWithImage"] = "Brand_Header_With_Image";
  WidgetId2["BrandHeaderWithVideo"] = "Brand_Header_With_Video";
  WidgetId2["BrandHeaderWithMultipleImages"] = "Brand_Header_With_Multiple_Images";
  WidgetId2["BrandHeaderWithMultipleVideos"] = "Brand_Header_With_Multiple_Videos";
  WidgetId2["EditorialHeader"] = "Editorial_Header";
  WidgetId2["ProductDetails"] = "Product_Details";
  WidgetId2["BulletPoints"] = "Bullet_Points";
  WidgetId2["EditorialTitleAndParagraph"] = "Editorial_Title_and_Paragraph";
  WidgetId2["CenterTitle"] = "Center_Title";
  WidgetId2["CenterTitleAndParagraph"] = "Center_Title_and_Paragraph";
  WidgetId2["VisualSpacer"] = "Visual_Spacer";
  WidgetId2["SixRectangleBoxes"] = "Six_Rectangle_Boxes";
  WidgetId2["CenterProductHero"] = "Center_Product_Hero";
  WidgetId2["LargeCenterVideo"] = "Large_Center_Video";
  WidgetId2["RectangleImageCarousel"] = "Rectangle_Image_Carousel";
  WidgetId2["ShortWideBanner"] = "Short_Wide_Banner";
  WidgetId2["LargeCenterImage"] = "Large_Center_Image";
  WidgetId2["LargeCenterBannerWithTiles"] = "Large_Center_Banner_With_Tiles";
  WidgetId2["MediumCenterImage"] = "Medium_Center_Image";
  WidgetId2["SideBySideImages"] = "Side_by_Side_Images";
  WidgetId2["ImageAndText"] = "Image_and_Text";
  WidgetId2["TextAndImage"] = "Text_and_Image";
  WidgetId2["SideBySideProducts"] = "Side_by_Side_Products";
  WidgetId2["ProductAndText"] = "Product_and_Text";
  WidgetId2["TextAndProduct"] = "Text_and_Product";
  WidgetId2["PopularProducts"] = "Popular_Products";
  WidgetId2["CuratedProducts"] = "Curated_Products";
  WidgetId2["ThreeSpotlightImages"] = "Three_Spotlight_Images";
  WidgetId2["TiledImages"] = "Tiled_Images";
  WidgetId2["TextCarousel"] = "Text_Carousel";
  WidgetId2["VideoCarousel"] = "Video_Carousel";
  WidgetId2["FiveShortFeatures"] = "Five_Short_Features";
  WidgetId2["ThreeDetailedFeatures"] = "Three_Detailed_Features";
  WidgetId2["SixDetailedFeatures"] = "Six_Detailed_Features";
  WidgetId2["VideoAndText"] = "Video_and_Text";
  WidgetId2["TextAndVideo"] = "Text_and_Video";
  WidgetId2["VideoAndProduct"] = "Video_and_Product";
  WidgetId2["ProductAndVideo"] = "Product_and_Video";
  WidgetId2["BrandclubRewardCarousel"] = "Brandclub_Reward_Carousel";
  WidgetId2["BrandclubProductRewardCarousel"] = "Brandclub_Product_Reward_Carousel";
  WidgetId2["BrandclubAppDownload"] = "Brandclub_App_Download";
  WidgetId2["BrandclubHowItWorks"] = "Brandclub_How_It_Works";
  WidgetId2["BrandclubCenterDownload"] = "Brandclub_Center_Download";
  WidgetId2["BrandclubVideoCarousel"] = "Brandclub_Video_Carousel";
  WidgetId2["BrandclubShopRetailers"] = "Brandclub_Shop_Retailers";
  WidgetId2["BrandclubCashBack"] = "Brandclub_Cash_Back";
  WidgetId2["BrandclubAffiliateRewards"] = "Brandclub_Affiliate_Rewards";
  WidgetId2["BrandclubSurveyRewards"] = "Brandclub_Survey_Rewards";
  WidgetId2["BrandclubTestimonialCarousel"] = "Brandclub_Testimonial_Carousel";
  WidgetId2["BrandclubGetApp"] = "Brandclub_Get_App";
  WidgetId2["BrandclubRightDownload"] = "Brandclub_Right_Download";
  WidgetId2["BrandNavigationAndSearchBar"] = "Brand_Navigation_and_Search_Bar";
  WidgetId2["SearchResults"] = "Search_Results";
  WidgetId2["BrandclubPageCards"] = "Brandclub_Page_Cards";
  WidgetId2["EditorialMoreFromCards"] = "Editorial_More_From_Cards";
  WidgetId2["BrandclubFooter"] = "Brandclub_Footer";
  return WidgetId2;
})(WidgetId || {});
var WidgetConfigStatus = /* @__PURE__ */ ((WidgetConfigStatus2) => {
  WidgetConfigStatus2["Enabled"] = "ENABLED";
  WidgetConfigStatus2["Disabled"] = "DISABLED";
  return WidgetConfigStatus2;
})(WidgetConfigStatus || {});
var WidgetAssetType = /* @__PURE__ */ ((WidgetAssetType2) => {
  WidgetAssetType2["Brandclub"] = "brandclub";
  WidgetAssetType2["Text"] = "text";
  WidgetAssetType2["Image"] = "image";
  WidgetAssetType2["Product"] = "product";
  WidgetAssetType2["Video"] = "video";
  WidgetAssetType2["Spotlight"] = "spotlight";
  return WidgetAssetType2;
})(WidgetAssetType || {});
var WidgetBuilderType = /* @__PURE__ */ ((WidgetBuilderType2) => {
  WidgetBuilderType2["Text"] = "text";
  WidgetBuilderType2["Video"] = "video";
  WidgetBuilderType2["Image"] = "image";
  WidgetBuilderType2["Product"] = "product";
  WidgetBuilderType2["Category"] = "category";
  WidgetBuilderType2["Subcategory"] = "subcategory";
  WidgetBuilderType2["Link"] = "link";
  WidgetBuilderType2["Nested"] = "nested";
  WidgetBuilderType2["NumberRange"] = "numberRange";
  WidgetBuilderType2["None"] = "none";
  return WidgetBuilderType2;
})(WidgetBuilderType || {});
var InputPropsValue = /* @__PURE__ */ ((InputPropsValue2) => {
  InputPropsValue2["List"] = "list";
  InputPropsValue2["Display"] = "display";
  InputPropsValue2["StacklineSKU"] = "stacklineSku";
  return InputPropsValue2;
})(InputPropsValue || {});
var WidgetInputComponent = /* @__PURE__ */ ((WidgetInputComponent2) => {
  WidgetInputComponent2["Slider"] = "slider";
  WidgetInputComponent2["Radio"] = "radio";
  return WidgetInputComponent2;
})(WidgetInputComponent || {});
var WidgetPropType = /* @__PURE__ */ ((WidgetPropType2) => {
  WidgetPropType2["UserInput"] = "userInput";
  WidgetPropType2["React"] = "react";
  WidgetPropType2["Redux"] = "redux";
  return WidgetPropType2;
})(WidgetPropType || {});

// src/types/cms/site.ts
var CmsSiteType = /* @__PURE__ */ ((CmsSiteType2) => {
  CmsSiteType2["BrandStore"] = "BRAND_STORE";
  CmsSiteType2["Product"] = "PRODUCT";
  return CmsSiteType2;
})(CmsSiteType || {});
var CmsEntityType = /* @__PURE__ */ ((CmsEntityType2) => {
  CmsEntityType2["BaseEntity"] = "baseEntity";
  CmsEntityType2["Site"] = "site";
  CmsEntityType2["Page"] = "page";
  CmsEntityType2["Widget"] = "widget";
  CmsEntityType2["WidgetConfig"] = "widgetConfig";
  CmsEntityType2["Asset"] = "asset";
  return CmsEntityType2;
})(CmsEntityType || {});
var BrandclubCMSEntity = /* @__PURE__ */ ((BrandclubCMSEntity2) => {
  BrandclubCMSEntity2["Audience"] = "audience";
  BrandclubCMSEntity2["Brand"] = "brand";
  BrandclubCMSEntity2["Campaign"] = "campaign";
  BrandclubCMSEntity2["CompanyDivision"] = "companyDivision";
  BrandclubCMSEntity2["Customer"] = "customer";
  BrandclubCMSEntity2["Product"] = "product";
  BrandclubCMSEntity2["Reward"] = "reward";
  BrandclubCMSEntity2["Profile"] = "profile";
  return BrandclubCMSEntity2;
})(BrandclubCMSEntity || {});
var PublishState = /* @__PURE__ */ ((PublishState2) => {
  PublishState2["Draft"] = "DRAFT";
  PublishState2["Published"] = "PUBLISHED";
  PublishState2["Archived"] = "ARCHIVED";
  PublishState2["Unpublished"] = "UNPUBLISHED";
  return PublishState2;
})(PublishState || {});

// src/types/boolQuery/index.ts
function isBoolQuery(query) {
  return typeof query === "object" && ["must", "must_not", "should"].some((x) => x in query && Array.isArray(query[x]));
}
function isSimpleBoolQuery(query) {
  var _a, _b, _c, _d, _e, _f;
  return isBoolQuery(query) && (!((_a = query.must) == null ? void 0 : _a.length) || ((_b = query.must) == null ? void 0 : _b.every((x) => isSimpleClause(x)))) && (!((_c = query.must_not) == null ? void 0 : _c.length) || ((_d = query.must_not) == null ? void 0 : _d.every((x) => isSimpleClause(x)))) && (!((_e = query.should) == null ? void 0 : _e.length) || ((_f = query.should) == null ? void 0 : _f.every((x) => isSimpleClause(x)))) ? true : false;
}
function isBoolSubQuery(query) {
  return typeof query === "object" && "bool" in query && isBoolQuery(query.bool);
}
function isTermQuery(query) {
  return typeof query === "object" && Object.keys(query).length === 1 && Object.keys(query)[0] === "term" && Object.values(query).length === 1 && !Array.isArray(Object.values(Object.values(query)[0])[0]);
}
function isTermsQuery(query) {
  return typeof query === "object" && Object.keys(query).length === 1 && Object.keys(query)[0] === "terms" && Object.values(query).length === 1 && Array.isArray(Object.values(Object.values(query)[0])[0]);
}
function isRangeQuery(query) {
  return typeof query === "object" && Object.keys(query).length === 1 && Object.keys(query)[0] === "range" && Object.values(query).length === 1 && typeof Object.values(query)[0] === "object" && ["gte", "gt", "lte", "lt"].some((x) => x in Object.values(Object.values(query)[0])[0]);
}
function isSimpleClause(query) {
  return isTermQuery(query) || isTermsQuery(query) || isRangeQuery(query) ? true : false;
}

// src/types/data-utils/date-math.ts
function adjustDate(date, amount, unit) {
  switch (unit) {
    case "y":
      date.setFullYear(date.getFullYear() + amount);
      break;
    case "M":
      date.setMonth(date.getMonth() + amount);
      break;
    case "w":
      date.setDate(date.getDate() + 7 * amount);
      break;
    case "d":
      date.setDate(date.getDate() + amount);
      break;
    case "h":
    case "H":
      date.setHours(date.getHours() + amount);
      break;
    case "m":
      date.setMinutes(date.getMinutes() + amount);
      break;
    case "s":
      date.setSeconds(date.getSeconds() + amount);
      break;
    default:
      throw new Error(`Invalid time unit: ${unit}`);
  }
}
function translateUnit(unit) {
  switch (unit) {
    case "y":
      return "year";
    case "M":
      return "month";
    case "w":
      return "week";
    case "d":
      return "day";
    case "h":
    case "H":
      return "hour";
    case "m":
      return "minute";
    case "s":
      return "second";
    default:
      throw new Error(`Invalid time unit: ${unit}`);
  }
}
var Regex = /(?:now|(?:\d{4}\.\d{2}\.\d{2}\|\|))((?:[+-]\d+[yMwdhHms]\/?d?)*)?/;
var isDateMathExpression = (dateExpression) => typeof dateExpression === "string" && Regex.test(dateExpression) ? true : false;
function parseDateMathExpressionToSQL(dateExpression) {
  let input = dateExpression;
  let sql;
  if (input.startsWith("now")) {
    input = input.slice(3);
    sql = "now()";
  } else {
    const match = input.match(/(.+)\|\|/);
    if (!match) {
      throw new Error(`Invalid date math string: ${dateExpression}`);
    }
    const dateString = match[1];
    input = input.slice(dateString.length + 2);
    sql = "('" + dateString.replace(/\./g, "-") + "')::date";
  }
  if (input) {
    const operations = input.match(/([+-]\d+[yMwdhHms]\/?d?)/g);
    if (!operations) {
      throw new Error(`Invalid operations: ${dateExpression}`);
    }
    for (const op of operations) {
      const match = op.match(/([+-])(\d+)([yMwdhHms])(?:\/([d]))?/);
      if (!match) {
        throw new Error(`Invalid operation: ${op} in ${dateExpression}`);
      }
      const [_, sign, amount, unit, round] = match;
      const interval = `${sign === "+" ? "+" : "-"} interval '${amount} ${translateUnit(unit)}'`;
      sql += ` ${interval}`;
      if (round) {
        switch (round) {
          case "d":
            sql = `(${sql})::date`;
            break;
          default:
            throw new Error(`Invalid date roundType: ${round} in ${dateExpression}`);
        }
      }
    }
  }
  return sql;
}
function parseDateMathExpression(dateExpression) {
  if (!isDateMathExpression(dateExpression)) {
    throw new Error(`Invalid date math string: ${dateExpression}`);
  }
  let input = dateExpression;
  let date;
  if (input.startsWith("now")) {
    date = /* @__PURE__ */ new Date();
    input = input.slice(3);
  } else {
    const match = input.match(/(.+)\|\|/);
    if (!match) {
      throw new Error(`Invalid date math string: ${dateExpression}`);
    }
    const dateString = match[1];
    date = new Date(dateString.replace(/\./g, "-"));
    if (isNaN(date.getTime())) {
      throw new Error(`Invalid date string: ${dateString} in ${dateExpression}`);
    }
    input = input.slice(dateString.length + 2);
  }
  if (input) {
    const operations = input.match(/([+-]\d+[yMwdhHms]\/?d?)/g);
    if (!operations) {
      throw new Error(`Invalid operations: ${dateExpression}`);
    }
    for (const op of operations) {
      const match = op.match(/([+-])(\d+)([yMwdhHms])(?:\/([d]))?/);
      if (!match) {
        throw new Error(`Invalid operation: ${op} in ${dateExpression}`);
      }
      const [_, sign, amount, unit, round] = match;
      adjustDate(date, Number(sign + amount), unit);
      if (round) {
        switch (round) {
          case "d":
            date.setHours(0, 0, 0, 0);
            break;
          default:
            throw new Error(`Invalid date roundType: ${round} in ${dateExpression}`);
        }
      }
    }
  }
  return date;
}

// src/types/data-utils/dateUtils.ts
import { DateTime } from "luxon";
import moment from "moment-timezone";
var getStartAndEndDateFromWeekId = ({ weekId }) => {
  const year = weekId.toString().slice(0, 4);
  const week = weekId.toString().slice(4);
  const startDate = moment().utc().isoWeekYear(parseInt(year)).isoWeek(parseInt(week)).startOf("isoWeek").subtract(1, "day");
  const endDate = moment(startDate.clone().add(7, "days").valueOf() - 1);
  return {
    startDate: startDate.toDate(),
    endDate: endDate.toDate()
  };
};
var getPreviousWeekId = (weekId = getWeekId(/* @__PURE__ */ new Date()), weeksToSubtract = 1) => {
  const { startDate } = getStartAndEndDateFromWeekId({ weekId });
  return getWeekId(
    moment.utc(startDate).add(-7 * weeksToSubtract, "d").toDate()
  );
};
var getNextWeekId = (weekId = getWeekId(/* @__PURE__ */ new Date()), weeksToAdd = 1) => {
  const { startDate } = getStartAndEndDateFromWeekId({ weekId });
  return getWeekId(
    moment.utc(startDate).add(7 * weeksToAdd, "d").toDate()
  );
};
var getWeekId = (date) => {
  let instance;
  if (typeof date === "string" && date.length) {
    instance = new Date(date);
  } else if (typeof date === "number") {
    instance = new Date(date);
  } else if (date instanceof Date) {
    instance = date;
  } else {
    instance = /* @__PURE__ */ new Date();
  }
  const target = new Date(instance.valueOf());
  const dayNr = instance.getUTCDay();
  target.setUTCDate(target.getUTCDate() - dayNr + 3);
  const firstThursday = target.valueOf();
  target.setUTCMonth(0, 1);
  if (target.getUTCDay() !== 4) {
    target.setUTCMonth(0, 1 + (4 - target.getUTCDay() + 7) % 7);
  }
  const weekNumber = 1 + Math.ceil((firstThursday - target.valueOf()) / 6048e5);
  return target.getUTCFullYear() * 100 + weekNumber;
};
function isLeapYear(year) {
  return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}
function getSDSWeeksInYear(year) {
  const jan1 = DateTime.fromObject({ year, month: 1, day: 1 }, { zone: "utc" });
  const jan1WeekDay = jan1.weekday;
  return jan1WeekDay === 3 || isLeapYear(year) && jan1WeekDay === 4 ? 53 : 52;
}
function getSDSWeekStartDate(year, week) {
  const jan1 = DateTime.fromObject({ year, month: 1, day: 1 }, { zone: "utc" });
  const jan1WeekDay = jan1.weekday;
  const firstWednesdayDay = (10 - jan1WeekDay) % 7 + 1;
  const firstWednesday = DateTime.fromObject({ year, month: 1, day: firstWednesdayDay }, { zone: "utc" });
  const week1Start = firstWednesday.minus({ days: 3 });
  return week1Start.plus({ days: (week - 1) * 7 });
}
function getSDSWeekYearInfo(dt) {
  let year = dt.year;
  const jan1 = DateTime.fromObject({ year, month: 1, day: 1 }, { zone: "utc" });
  const jan1WeekDay = jan1.weekday;
  const firstWednesdayDay = (10 - jan1WeekDay) % 7 + 1;
  const firstWednesday = DateTime.fromObject({ year, month: 1, day: firstWednesdayDay }, { zone: "utc" });
  const week1Start = firstWednesday.minus({ days: 3 });
  if (dt < week1Start) {
    year--;
    return { year, week: getSDSWeeksInYear(year) };
  }
  const daysSinceWeek1Start = Math.floor(dt.diff(week1Start, "days").days);
  let week = Math.floor(daysSinceWeek1Start / 7) + 1;
  const nextYearJan1 = DateTime.fromObject({ year: year + 1, month: 1, day: 1 }, { zone: "utc" });
  const nextYearJan1WeekDay = nextYearJan1.weekday;
  const nextYearFirstWednesdayDay = (10 - nextYearJan1WeekDay) % 7 + 1;
  const nextYearFirstWednesday = DateTime.fromObject(
    { year: year + 1, month: 1, day: nextYearFirstWednesdayDay },
    { zone: "utc" }
  );
  const nextYearWeek1Start = nextYearFirstWednesday.minus({ days: 3 });
  if (dt >= nextYearWeek1Start) {
    return { year: year + 1, week: 1 };
  }
  const weeksInYear = getSDSWeeksInYear(year);
  if (week > weeksInYear) {
    week = weeksInYear;
  }
  return { year, week };
}
function toUTCDateTime(date) {
  let instance;
  if (typeof date === "string" && date.length) {
    instance = new Date(date);
  } else if (typeof date === "number") {
    instance = new Date(date);
  } else if (date instanceof Date) {
    instance = date;
  } else {
    instance = /* @__PURE__ */ new Date();
  }
  const year = instance.getUTCFullYear();
  const month = instance.getUTCMonth() + 1;
  const day = instance.getUTCDate();
  return DateTime.fromObject({ year, month, day }, { zone: "utc" });
}
var getSDSWeekId = (date) => {
  const dt = toUTCDateTime(date);
  const { year, week } = getSDSWeekYearInfo(dt);
  return year * 100 + week;
};
var getStartAndEndDateFromSDSWeekId = ({ weekId }) => {
  const yearStr = weekId.toString().slice(0, 4);
  const weekStr = weekId.toString().slice(4);
  const year = Number.parseInt(yearStr, 10);
  const week = Number.parseInt(weekStr, 10);
  const weeksInYear = getSDSWeeksInYear(year);
  if (week < 1 || week > weeksInYear) {
    throw new Error(`Invalid week number ${week} for year ${year}. Must be between 1 and ${weeksInYear}`);
  }
  const startDate = getSDSWeekStartDate(year, week);
  const endDate = startDate.plus({ days: 7 }).minus({ milliseconds: 1 });
  return {
    startDate: startDate.toJSDate(),
    endDate: endDate.toJSDate()
  };
};
var getPreviousSDSWeekId = (weekId = getSDSWeekId(), weeksToSubtract = 1) => {
  const { startDate } = getStartAndEndDateFromSDSWeekId({ weekId });
  const previousDate = DateTime.fromJSDate(startDate, { zone: "utc" }).minus({ days: 7 * weeksToSubtract });
  const { year, week } = getSDSWeekYearInfo(previousDate);
  return year * 100 + week;
};
var getNextSDSWeekId = (weekId = getSDSWeekId(), weeksToAdd = 1) => {
  const { startDate } = getStartAndEndDateFromSDSWeekId({ weekId });
  const nextDate = DateTime.fromJSDate(startDate, { zone: "utc" }).plus({ days: 7 * weeksToAdd });
  const { year, week } = getSDSWeekYearInfo(nextDate);
  return year * 100 + week;
};

// src/types/retailerSync/browserPlatform.ts
var BrowserPlatForm = /* @__PURE__ */ ((BrowserPlatForm2) => {
  BrowserPlatForm2["MAC"] = "Mac";
  BrowserPlatForm2["WINDOWS"] = "Win";
  BrowserPlatForm2["LINUX"] = "Linux";
  return BrowserPlatForm2;
})(BrowserPlatForm || {});

// src/types/retailerSync/scanRequests.ts
var WalmartScanRequestType = /* @__PURE__ */ ((WalmartScanRequestType2) => {
  WalmartScanRequestType2["ORDER_DETAIL"] = "orderDetail";
  WalmartScanRequestType2["ORDER_RECEIPTS"] = "orderReceipts";
  WalmartScanRequestType2["GRAPHQL_REQUESTS"] = "graphQlRequests";
  return WalmartScanRequestType2;
})(WalmartScanRequestType || {});

// src/types/retailerSync/index.ts
var RetailerSyncModeTypes = /* @__PURE__ */ ((RetailerSyncModeTypes2) => {
  RetailerSyncModeTypes2["CLIENT_SIDE"] = "clientSide";
  RetailerSyncModeTypes2["SERVER_SIDE"] = "serverSide";
  RetailerSyncModeTypes2["HYBRID"] = "hybrid";
  return RetailerSyncModeTypes2;
})(RetailerSyncModeTypes || {});
var RetailerSyncReferrerTypes = /* @__PURE__ */ ((RetailerSyncReferrerTypes2) => {
  RetailerSyncReferrerTypes2["ONBOARDING"] = "onBoarding";
  RetailerSyncReferrerTypes2["SYNC_ALL"] = "syncAll";
  RetailerSyncReferrerTypes2["ACCOUNTS_PAGE"] = "accountsPage";
  RetailerSyncReferrerTypes2["ACCOUNTS_CAROUSEL"] = "accountsCarousel";
  RetailerSyncReferrerTypes2["REVIEWS"] = "reviews";
  RetailerSyncReferrerTypes2["AUTO_SYNC"] = "autoSync";
  RetailerSyncReferrerTypes2["CHECKOUT"] = "checkout";
  RetailerSyncReferrerTypes2["FIX"] = "fix";
  return RetailerSyncReferrerTypes2;
})(RetailerSyncReferrerTypes || {});
var SyncInitiationTrigger = /* @__PURE__ */ ((SyncInitiationTrigger2) => {
  SyncInitiationTrigger2["CRAWLER"] = "crawler";
  SyncInitiationTrigger2["USER"] = "user";
  SyncInitiationTrigger2["TEST"] = "test";
  SyncInitiationTrigger2["AUTO_SYNC"] = "auto_sync";
  SyncInitiationTrigger2["CHECKOUT"] = "checkout";
  SyncInitiationTrigger2["ADMIN"] = "admin";
  return SyncInitiationTrigger2;
})(SyncInitiationTrigger || {});
var RetailerSyncFlowTypes = /* @__PURE__ */ ((RetailerSyncFlowTypes2) => {
  RetailerSyncFlowTypes2["CONNECT_ONLY"] = "connect_only";
  RetailerSyncFlowTypes2["CONNECT"] = "connect";
  RetailerSyncFlowTypes2["FIX"] = "fix";
  RetailerSyncFlowTypes2["RETRY_SYNC"] = "retrySync";
  RetailerSyncFlowTypes2["SYNC"] = "sync";
  RetailerSyncFlowTypes2["AUTO_SYNC"] = "autoSync";
  RetailerSyncFlowTypes2["CHECKOUT"] = "checkout";
  return RetailerSyncFlowTypes2;
})(RetailerSyncFlowTypes || {});

// src/types/browser/browserType.ts
var BrowserType = /* @__PURE__ */ ((BrowserType2) => {
  BrowserType2["Default"] = "default";
  BrowserType2["Chromium"] = "chromium";
  BrowserType2["CustomChromiumStable"] = "customChromiumStable";
  BrowserType2["PuppetBridge"] = "puppetBridge";
  BrowserType2["PuppetBridgeBrave"] = "puppetBridgeBrave";
  BrowserType2["PuppetBridgeCustomChromium"] = "puppetBridgeCustomChromium";
  BrowserType2["PuppetBridgeCustomBrave"] = "puppetBridgeCustomBrave";
  BrowserType2["PuppetBridgeAndroid"] = "puppetBridgeAndroid";
  BrowserType2["CustomBrave"] = "customBrave";
  BrowserType2["BrowserLess"] = "browserLess";
  BrowserType2["BrowserCDP"] = "browserCDP";
  return BrowserType2;
})(BrowserType || {});
var isBrowserType = (browserType) => {
  return Object.values(BrowserType).includes(browserType);
};
var isPuppetBridgeBrowser = (browserType) => {
  return browserType === "puppetBridge" /* PuppetBridge */ || browserType === "puppetBridgeBrave" /* PuppetBridgeBrave */ || browserType === "puppetBridgeCustomChromium" /* PuppetBridgeCustomChromium */ || browserType === "puppetBridgeAndroid" /* PuppetBridgeAndroid */;
};

// src/types/browser/browserAgent.ts
var WorkflowStatus = /* @__PURE__ */ ((WorkflowStatus2) => {
  WorkflowStatus2["PENDING"] = "pending";
  WorkflowStatus2["RUNNING"] = "running";
  WorkflowStatus2["COMPLETED"] = "completed";
  WorkflowStatus2["FAILED"] = "failed";
  WorkflowStatus2["CANCELLED"] = "cancelled";
  return WorkflowStatus2;
})(WorkflowStatus || {});
var ModelProviderType = /* @__PURE__ */ ((ModelProviderType2) => {
  ModelProviderType2["ANTHROPIC_BEDROCK"] = "anthropic-bedrock";
  ModelProviderType2["ANTHROPIC"] = "anthropic";
  ModelProviderType2["OPENAI"] = "openai";
  ModelProviderType2["OLLAMA"] = "ollama";
  return ModelProviderType2;
})(ModelProviderType || {});

// src/types/fulfillment/channel.ts
var ALL_CHANNEL_TYPES = ["shopify", "walmart", "tiktok"];
var SUPPORTED_CHANNEL_TYPES = ["shopify", "walmart"];
var MARKETPLACE_CHANNEL_TYPES = ["walmart", "tiktok"];
var STOREFRONT_CHANNEL_TYPES = ["shopify"];
function isMarketplaceChannelType(type) {
  return MARKETPLACE_CHANNEL_TYPES.includes(type != null ? type : "");
}
var DEFAULT_CHANNEL_CAPABILITIES = {
  shopify: {
    catalogImport: true,
    metadataPush: true,
    inventorySync: true,
    orderIngestion: false,
    fulfillmentSync: true,
    webhookSupport: true,
    supportsBulkPush: true,
    channelOrderCreation: true
  },
  walmart: {
    catalogImport: true,
    metadataPush: false,
    inventorySync: false,
    orderIngestion: true,
    fulfillmentSync: true,
    webhookSupport: true,
    supportsBulkPush: false,
    channelOrderCreation: false
  },
  tiktok: {
    catalogImport: false,
    metadataPush: false,
    inventorySync: false,
    orderIngestion: true,
    fulfillmentSync: true,
    webhookSupport: true,
    supportsBulkPush: false,
    channelOrderCreation: false
  }
};
var CHANNEL_ENFORCED_POLICIES = {
  walmart: { blockAmzl: "required" }
};

// src/types/fulfillment/policy.ts
var MCF_DEFAULT_FEATURE_POLICIES = {
  blankBox: "inherit",
  blockAmzl: "inherit",
  overbox: "inherit",
  packingSlip: "inherit",
  signatureConfirmation: "inherit"
};

// src/types/fulfillment/connection.ts
var FulfillmentProviderType = /* @__PURE__ */ ((FulfillmentProviderType2) => {
  FulfillmentProviderType2["AmazonMCF"] = "AmazonMCF";
  return FulfillmentProviderType2;
})(FulfillmentProviderType || {});
var FulfillmentConnectionStatus = /* @__PURE__ */ ((FulfillmentConnectionStatus2) => {
  FulfillmentConnectionStatus2["Active"] = "active";
  FulfillmentConnectionStatus2["PendingAuthorization"] = "pending_authorization";
  FulfillmentConnectionStatus2["Inactive"] = "inactive";
  FulfillmentConnectionStatus2["Error"] = "error";
  return FulfillmentConnectionStatus2;
})(FulfillmentConnectionStatus || {});
var FulfillmentEnvironment = /* @__PURE__ */ ((FulfillmentEnvironment2) => {
  FulfillmentEnvironment2["Production"] = "production";
  FulfillmentEnvironment2["Sandbox"] = "sandbox";
  return FulfillmentEnvironment2;
})(FulfillmentEnvironment || {});

// src/types/fulfillment/order.ts
var FulfillmentOrderStatus = /* @__PURE__ */ ((FulfillmentOrderStatus2) => {
  FulfillmentOrderStatus2["PENDING"] = "pending";
  FulfillmentOrderStatus2["PROCESSING"] = "processing";
  FulfillmentOrderStatus2["SHIPPED"] = "shipped";
  FulfillmentOrderStatus2["PARTIALLY_SHIPPED"] = "partially_shipped";
  FulfillmentOrderStatus2["DELIVERED"] = "delivered";
  FulfillmentOrderStatus2["CANCELLED"] = "cancelled";
  FulfillmentOrderStatus2["ERROR"] = "error";
  return FulfillmentOrderStatus2;
})(FulfillmentOrderStatus || {});
var FulfillmentSyncStatus = /* @__PURE__ */ ((FulfillmentSyncStatus2) => {
  FulfillmentSyncStatus2["Pending"] = "pending";
  FulfillmentSyncStatus2["Syncing"] = "syncing";
  FulfillmentSyncStatus2["Synced"] = "synced";
  FulfillmentSyncStatus2["Error"] = "error";
  return FulfillmentSyncStatus2;
})(FulfillmentSyncStatus || {});
var FulfillmentJobType = /* @__PURE__ */ ((FulfillmentJobType2) => {
  FulfillmentJobType2["CREATE_ORDER"] = "create_order";
  FulfillmentJobType2["UPDATE_ORDER"] = "update_order";
  FulfillmentJobType2["CANCEL_ORDER"] = "cancel_order";
  FulfillmentJobType2["SYNC_INVENTORY"] = "sync_inventory";
  FulfillmentJobType2["GET_TRACKING"] = "get_tracking";
  FulfillmentJobType2["SYNC_TO_CHANNEL"] = "sync_to_channel";
  FulfillmentJobType2["SYNC_TO_MARKETPLACE"] = "sync_to_marketplace";
  FulfillmentJobType2["IMPORT_CHANNEL_PRODUCTS"] = "import_channel_products";
  return FulfillmentJobType2;
})(FulfillmentJobType || {});
export {
  ALL_CHANNEL_TYPES,
  APP_ACTIONS,
  AuthStateEnum,
  BrandclubCMSEntity,
  BrandclubPageType,
  BrowserPlatForm,
  BrowserType,
  CHANNEL_ENFORCED_POLICIES,
  CampaignFundSource,
  CampaignStatus,
  CampaignTargetingType,
  CampaignType,
  CmsEntityType,
  CmsSiteType,
  ContractType,
  CustomerBrandCommunicationType,
  DEFAULT_CHANNEL_CAPABILITIES,
  DEFAULT_DELIVERY_FEE_THRESHOLD,
  EligibilityStatus,
  FulfillmentConnectionStatus,
  FulfillmentEnvironment,
  FulfillmentJobType,
  FulfillmentOrderStatus,
  FulfillmentProviderType,
  FulfillmentSyncStatus,
  InputPropsValue,
  MARKETPLACE_CHANNEL_TYPES,
  MCF_DEFAULT_FEATURE_POLICIES,
  MessageChannelType,
  MessagingCampaignActivationType,
  MessagingCampaignTriggerMechanism,
  MessagingCampaignType,
  ModelProviderType,
  NotificationStatus,
  NotificationType,
  NotificationTypeCategory,
  NotificationsConstants,
  OrderEligibility,
  OrderPurchaseType,
  OrderSource,
  OriginAppType,
  PageStatus,
  PaymentStatus,
  PublishState,
  QualifyingOrderPurchaseType,
  RetailerReviewConfigStatus,
  RetailerSyncFlowTypes,
  RetailerSyncModeTypes,
  RetailerSyncReferrerTypes,
  RewardAppTargetingPlatformsType,
  RewardProcessingStatus,
  RewardStatus,
  RewardType,
  RewardUnlockStrategy,
  STOREFRONT_CHANNEL_TYPES,
  SUPPORTED_CHANNEL_TYPES,
  SessionState,
  SubAudienceType,
  SyncInitiationTrigger,
  UserStatus,
  WalmartScanRequestType,
  WidgetAssetType,
  WidgetBuilderType,
  WidgetConfigStatus,
  WidgetId,
  WidgetInputComponent,
  WidgetPropType,
  WorkflowStatus,
  getCampaignTypeDisplayName,
  getNextSDSWeekId,
  getNextWeekId,
  getPreviousSDSWeekId,
  getPreviousWeekId,
  getSDSWeekId,
  getStartAndEndDateFromSDSWeekId,
  getStartAndEndDateFromWeekId,
  getWeekId,
  inboxNotificationTypes,
  isBoolQuery,
  isBoolSubQuery,
  isBrowserType,
  isDateMathExpression,
  isMarketplaceChannelType,
  isPuppetBridgeBrowser,
  isRangeQuery,
  isSimpleBoolQuery,
  isSimpleClause,
  isTermQuery,
  isTermsQuery,
  parseDateMathExpression,
  parseDateMathExpressionToSQL,
  rewardDisplayNames,
  rewardShortDisplayNames
};
//# sourceMappingURL=index.mjs.map